import CircleIcon from "@mui/icons-material/Circle"
import Chip from "@mui/material/Chip"
import { styled } from "@mui/material/styles"

export default styled(Chip)(({ theme }) => ({
  borderRadius: "6px",
  border: `1px solid ${theme.palette.colors.gray300}`,
  fontSize: "12px",
  fontWeight: 500,
  backgroundColor: "white",
  "& .MuiChip-label": {
    paddingRight: "8px",
  },
}))

const SmallCircleIcon = styled(CircleIcon)(() => ({
  width: "6px",
}))

export const GreenCircleIcon = styled(SmallCircleIcon)(({ theme }) => ({
  fill: theme.palette.colors.success500,
}))

export const PinkCircleIcon = styled(SmallCircleIcon)(({ theme }) => ({
  fill: theme.palette.secondary.light,
}))

export const GrayCircleIcon = styled(SmallCircleIcon)(({ theme }) => ({
  fill: theme.palette.colors.gray500,
}))
